import { Component } from '@angular/core';
import {MatCard} from '@angular/material/card';
import {MatIconButton} from '@angular/material/button';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {BaseStateReportWidget} from '../base-state-report-widget';
import domtoimage from 'dom-to-image';
import JSZip from 'jszip';

@Component({
  selector: 'tgrid-restoration-metric-description-widget',
    imports: [
        MatCard,
        MatIconButton,
        VulcanIconComponent,
    ],
  templateUrl: './restoration-metric-description-widget.component.html',
  styleUrl: './restoration-metric-description-widget.component.scss',
})
export class RestorationMetricDescriptionWidgetComponent extends BaseStateReportWidget {
  protected async export(): Promise<void> {
    const container = this.exportContent()?.nativeElement;
    if (!container) return;

    // --- TXT ---
    const content = container.innerText;

    // --- PNG ---
    const dataUrl = await domtoimage.toPng(container, {
      bgcolor: '#ffffff',
      filter: (node) => !(node instanceof HTMLElement && node.hasAttribute('data-html2canvas-ignore')),
    });
    const base64 = dataUrl.split(',')[1];

    // --- Zip ---
    const zip = new JSZip();
    zip.file('restoration-metric-description.txt', content);
    zip.file('restoration-metric-description.png', base64, { base64: true });

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    const pngAnchor = document.createElement('a');
    pngAnchor.href = URL.createObjectURL(zipBlob);
    pngAnchor.download = 'restoration-metric-description.zip';
    pngAnchor.click();
  }
}
